module.exports = require("./exif.js");


//////////////////
// WEBPACK FOOTER
// exif-js (bower component)
// module id = 259
// module chunks = 0